import React from "react";

const Give = () =>{
  return (
    <section className="try--pd">
       <div>
         <h2 className="business--handler">Let’s try our service now!</h2>
         <p className="bs--content ds--colors ct--color">Everything you need to accept card payments and grow your business anywhere on the planet.</p>
       </div><br/>
       <div>
           <button className="bs--btn">Get Started</button><br /><br />
       </div>
    </section>
  );
}

export default Give;